import { notification } from "antd";
import { AxiosError } from "axios";
import { IconAlert, IconAlertSuccess } from "../../assets";
import { Body2 } from "../Typography";
import styles from "./LMNotifications.module.css";

export const getErrorMessage = (e: unknown): string | undefined => {
  if (e instanceof AxiosError) {
    return e.response?.data?.message || e.message;
  }
  if (e instanceof Error) {
    return e.message;
  }
  return undefined;
};

type Action = {
  name: string;
  callback: () => void;
};

const getMessageComponent = (message: string, action?: Action) => {
  if (action) {
    return (
      <Body2 className={styles.message}>
        {message}
        <button className={styles.button} onClick={action.callback}>
          {action.name}
        </button>
      </Body2>
    );
  }
  return <Body2 className={styles.message}>{message}</Body2>;
};

export const useAppNotifications = () => {
  const [api, contextHolder] = notification.useNotification();

  const success = (message: string, action?: Action) => {
    api.success({
      className: styles.container,
      message: getMessageComponent(message, action),
      icon: <IconAlertSuccess />,
      duration: 5,
    });
  };

  const warning = (message: string, action?: Action) => {
    api.warning({
      className: styles.container,
      message: getMessageComponent(message, action),
      icon: <IconAlert fill="var(--color-yellow-70)" />,
      duration: 5,
    });
  };

  const error = (message: string, errorDetails?: string, action?: Action) => {
    const fullMessage = errorDetails
      ? `${message}: ${errorDetails}`
      : message;
    api.error({
      className: styles.container,
      message: getMessageComponent(fullMessage, action),
      icon: <IconAlert fill="var(--color-red-70)" />,
      duration: 5,
    });
  };

  return {
    success,
    warning,
    error,
    contextHolder,
  };
};
